import styled from 'styled-components';

export const StyledPage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2.4rem;
  box-sizing: border-box;
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 56rem;
  padding: 4.8rem 5.6rem;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.greyScale.white};
  border-radius: ${(props) => props.theme.borderRadius.box};
  box-shadow: ${(props) => props.theme.shadows.box};

  @media (max-width: ${(props) => props.theme.medias.s.max}px) {
    padding: 3.2rem 2.4rem;
  }
`;

export const StyledLogo = styled.img`
  height: 4rem;
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.4rem;
  padding-bottom: 1.6rem;
  text-align: center;
`;

export const StyledTextContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 1.6rem;

  & span {
    max-width: 44rem;
    text-align: center;
  }
`;

export const StyledActionContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 3.2rem;
`;

export const StyledButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary.regular};
  padding: 1.6rem 2.4rem 1.2rem 2.4rem;
  border: none;
  border-radius: 0.4rem;
  font-weight: ${(props) => props.theme.font.weights.medium};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primary.dark};
  }
`;
